module.exports = __webpack_public_path__ + "static/a-xx-003-art-c43ace3431c3c2b1a47225c4dfd3b4f5.jpg";